import { render, staticRenderFns } from "./EditVehicleFleet.vue?vue&type=template&id=50524578&scoped=true"
import script from "./EditVehicleFleet.vue?vue&type=script&lang=js"
export * from "./EditVehicleFleet.vue?vue&type=script&lang=js"
import style0 from "./EditVehicleFleet.vue?vue&type=style&index=0&id=50524578&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50524578",
  null
  
)

export default component.exports